
import { GameRole } from '../../types/game';
import { GameState } from '../GameContextTypes';

export const startGame = (state: GameState, role: GameRole): GameState => {
  // Get the initial career title from the role
  const initialCareerTitle = role.careerPath.find(path => path.level === 'Junior')?.title || '';
  
  return {
    ...state,
    selectedRole: role,
    gameStarted: true,
    skills: role.startingSkills,
    careerLevel: 'Junior',
    careerPath: 'Standard',
    careerTitle: initialCareerTitle,
    experience: 0,
    yearsPassed: 1,
    kpis: {
      uptime: 95,
      energyCost: 0.08,
      profitMargin: 15,
      efficiency: 70,
    },
    achievements: [`Started career as ${role.title}`],
    decisionHistory: [],
    isSimulationComplete: false,
    completedChallenges: [] // Reset completed challenges
  };
};
